import type { AccountSource } from "owa-account-source-list-store";
import { BootState, onCoprincipalAccountAdded, onCoprincipalBootStateChanged, onPreCoprincipalAccountRemoved, } from "owa-account-source-list-store";
import onAppLicensingInfosChanged from "owa-account-source-list-store/lib/actions/onAppLicensingInfosChanged";
import { orchestrator } from "satcheljs";
import { computeEnterpriseOrPremiumLicenseStatus } from "../utils/computeEnterpriseOrPremiumLicenseStatus";

orchestrator(onCoprincipalAccountAdded, () => {
    computeEnterpriseOrPremiumLicenseStatus();
});

orchestrator(onCoprincipalBootStateChanged, (arg: {
    updatedAccount: AccountSource;
    newBootState: BootState;
}) => {
    if (arg.newBootState === BootState.StartupComplete) {
        computeEnterpriseOrPremiumLicenseStatus();
    }
});
orchestrator(onPreCoprincipalAccountRemoved, (args: {
    removedAccount: AccountSource;
}) => {
    computeEnterpriseOrPremiumLicenseStatus(args.removedAccount);
});

orchestrator(onAppLicensingInfosChanged, () => {
    computeEnterpriseOrPremiumLicenseStatus();
});
